import React, { useEffect } from "react"
import PassFailChips from "../components/pass-fail-chips"
import { StepResultTable } from "../components/step-result-table"
import StepToTitle from "../components/step-to-title"
import store from "../store"
import { getSimulationURL } from "../utils/get-simulation-library-url"
import sortSimulationsByExceptions from "../utils/sort-simulations-by-expectations"
import useAsyncEffect from "../utils/use-async-effect"
import { useLocalStorage } from "../utils/use-local-storage"
import { useStyleSheet } from "../utils/use-style-sheet"

export default function PrintSimulations() {
  store.useRerenderIfChange(() => [store.loadForPrinter, store.simulationListForPrint])
  var [showNames, set_showNames] = useLocalStorage("show-names", true)
  showNames = false // We do not want to be able to change it.
  useStyleSheet(`
  [class*=sidebar] {
    display:none;
  }
  [class*=MuiPaper] {
    display:none;
  }
  `)
  useAsyncEffect(() => {
    store.loadPrints()
  }, [])

  if (store.simulationListForPrint) {
    store.simulationListForPrint = sortSimulationsByExceptions(store.simulationListForPrint)
  }

  return <div>
    {false &&
      // We hide it so we can select all and copy to the document without that things
      <div className="hide-on-print">
        <span css={`
        cursor:pointer;
        color:blue;
        font-size:18px;
        `} onClick={store.backFromPrinting}>&lt; Back</span>
        &nbsp;
        <input
          type="checkbox"
          id="show-names"
          checked={showNames}
          onChange={e => set_showNames(e.target.checked)}
          css={`
        cursor:pointer;
        color:blue;
        font-size:18px;
        `} /><label htmlFor="show-names">Show Names</label>
      </div>}
    {store.loadForPrinter && "Loading..."}
    {!store.loadForPrinter && <div>
      {store?.simulationListForPrint?.map((simulation, simulationIndex) => {
        console.log({simulation})
        return <div key={simulationIndex}>
          <div
            onClick={() => {
              store.history.push(getSimulationURL({
                simulationId: simulation._id,
              }))
            }}
          >
            <h4 css={`
            cursor:pointer;
            font-family:arial;
            font-size: 30px;
            font-weight: 700;
          `}>
              <span css={`font-size:26px;opacity:0.7;`}>{String(simulation.sid).padStart(3, "0")}&nbsp;</span>
              {
                /* {simulationIndex+1}.&nbsp; */
              }
              {simulation.name}&nbsp;
              {showNames && <span css={`font-size:14px;font-weight:100;`}>by {simulation.userName}&nbsp;</span>}
              <PassFailChips pass_expections={simulation.pass_expections} />
            </h4>
          </div>
          {simulation.steps?.map((step, step_index) => {
            return <PrintStep
              key={step_index}
              testAndStepIndex={(simulationIndex + 1) + '.' + (step_index + 1) + '.'}
              step={step}
              results={simulation?.results?.[0]?.steps_output[step_index]} />
          })}
          <div css={`page-break-after: always;`} />
        </div>
      })}
    </div>}
  </div>
}
function PrintStep({ step, results, testAndStepIndex }) {
  console.log({step,results})
  var td = StepResultTable({
    step,
    showNames: true
  })
  return <div>
    <div css={`white-space:nowrap;font-weight:bolder;font-size:16px;margin-bottom:10px;border-bottom:1px solid black;`}>
      {testAndStepIndex}&nbsp;
      <StepToTitle step={step} showNames />
    </div>
    {!results && "Not executed yet"}
    {results &&
      <table width="100%">
        <tbody>
        {td.filter(x => !x.hideBasedOnOutput || !x.hideBasedOnOutput(results)).map((field, index) => (
          <tr key={JSON.stringify(field)}>
            <td valign="top" css={`font-weight:bolder;vertical-align:top;`}>{field.title}:</td>
            <td width="100%">
              {field.value(
                step,
                results,
              )}
            </td>
          </tr>
        ))}
        </tbody>
      </table>
    }
  </div>
}